import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/i18n";

const Section = ({ title, children }) => (
  <div className="mt-10">
    <h2 className="font-heading text-xl sm:text-2xl font-semibold tracking-tight text-[#0F2645]">{title}</h2>
    <div className="mt-4 text-sm sm:text-base leading-relaxed text-[#5C6A87] space-y-3">{children}</div>
  </div>
);

const content = {
  fr: {
    title: "Mentions légales",
    updated: "Dernière mise à jour : juin 2026",
    sections: [
      {
        title: "Éditeur du logiciel",
        body: [
          "Devisto Studio est un logiciel de devis et de facturation pour les artisans du bâtiment, développé et exploité par JMX Énergie.",
          "JMX Énergie · TVA BE 0786.236.171 · Woluwe-Saint-Étienne, Belgique",
          "Contact : info@devis-to.be · Site partenaire : jmx-energie.be",
        ],
      },
      {
        title: "Hébergement",
        body: ["L'application et les fichiers de ses utilisateurs sont hébergés au sein de l'Union européenne par Emergent (infrastructure cloud sécurisée)."],
      },
      {
        title: "Propriété intellectuelle",
        body: ["L'ensemble des contenus du site et du logiciel (textes, logo, interface, articles de blog) est la propriété de Devisto / JMX Énergie. Toute reproduction sans autorisation écrite est interdite. En revanche, les dossiers, devis, factures et documents créés par un abonné lui appartiennent intégralement."],
      },
    ],
  },
  nl: {
    title: "Wettelijke vermeldingen",
    updated: "Laatste update: juni 2026",
    sections: [
      {
        title: "Uitgever van de software",
        body: [
          "Devisto Studio is software voor bestekken en facturatie voor vakmensen in de bouw, ontwikkeld en beheerd door JMX Énergie.",
          "JMX Énergie · BTW BE 0786.236.171 · Sint-Stevens-Woluwe, België",
          "Contact: info@devis-to.be · Partnerwebsite: jmx-energie.be",
        ],
      },
      {
        title: "Hosting",
        body: ["De applicatie en de bestanden van haar gebruikers worden gehost binnen de Europese Unie door Emergent (beveiligde cloudinfrastructuur)."],
      },
      {
        title: "Intellectuele eigendom",
        body: ["Alle inhoud van de site en van de software (teksten, logo, interface, blogartikelen) is eigendom van Devisto / JMX Énergie. Elke reproductie zonder schriftelijke toestemming is verboden. De dossiers, bestekken, facturen en documenten die een abonnee aanmaakt, behoren daarentegen volledig aan hem toe."],
      },
    ],
  },
};

export default function LegalPage() {
  const { t, lang } = useLanguage();
  const c = content[lang] || content.fr;

  useEffect(() => {
    document.title = `${c.title} | Devisto`;
  }, [c.title]);

  return (
    <div data-testid="legal-page" className="font-body bg-[#F6F8FD] text-[#0F2645] min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 py-16 sm:py-24">
          <Reveal>
            <p className="text-sm font-bold tracking-[0.1em] uppercase text-[#3A5CC8]">{t("Informations légales")}</p>
            <h1 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F2645]">{c.title}</h1>
            <p className="mt-3 text-xs text-[#5C6A87]">{c.updated}</p>
          </Reveal>
          {c.sections.map((s) => (
            <Section key={s.title} title={s.title}>
              {s.body.map((p, i) => <p key={i}>{p}</p>)}
            </Section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
